import React from 'react';
import {render} from 'react-dom';
import Root from './root/Root';
import './index.css';
import configureStore from './store/configureStore';

import rootReducer from './reducers/index';

export const store = configureStore(rootReducer);

render(
  <Root store={store}/>,
  document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js